import { Link } from "react-router-dom";
import styled from "styled-components";

const MoonSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 290 290"
    className={`${props.className}`}
  >
    <circle cx="148" cy="140" r="140" fill="#DDDBD7" />
    <path
      fill="#A49C89"
      d="M144 205c16.569 0 29.5-8.431 29.5-25 0-4.843-1.105-9.845-3.083-14.5C165.629 154.231 155.725 145 144 145c-16.569 0-30 13.431-30 30 0 1.932.144 3.763.431 5.5 1.169 7.087 4.717 12.604 10.569 17 5.014 3.766 12.246 7.5 19 7.5z"
    />
    <path
      stroke="#281D1B"
      strokeOpacity=".1"
      d="M173 180c0 8.139-3.169 14.241-8.346 18.32-5.192 4.091-12.448 6.18-20.654 6.18-6.595 0-13.72-3.66-18.7-7.4-5.758-4.325-9.229-9.732-10.376-16.681A33.233 33.233 0 01114.5 175c0-16.292 13.208-29.5 29.5-29.5 11.45 0 21.213 9.031 25.957 20.196C171.912 170.295 173 175.231 173 180z"
    />
    <path
      fill="#887F6B"
      d="M167 161c-19-11.5-41-6-52 15-1-15 9.909-27.832 24-30 13-2 22.5 5.5 28 15z"
    />
    <path
      fill="#A49C89"
      d="M95.815 35.948c11.617-5.396 19.418-12.333 16.929-17.691-.727-1.566-2.253-2.824-4.339-3.685-5.05-2.084-13.38-1.843-21.602 1.975-11.617 5.396-19.017 14.114-16.529 19.471.29.625.666 1.17 1.128 1.638 1.885 1.91 5.2 2.54 9.964 2.055 4.082-.415 9.713-1.563 14.449-3.763z"
    />
    <path
      stroke="#281D1B"
      strokeOpacity=".1"
      d="M112.291 18.468c1.101 2.37-.012 5.216-3.075 8.266-3.033 3.021-7.83 6.075-13.612 8.761-4.669 2.169-10.242 3.307-14.288 3.719-4.737.482-7.844-.17-9.558-1.909a5.272 5.272 0 01-1.03-1.498c-1.113-2.395-.063-5.694 2.902-9.186 2.935-3.457 7.626-6.946 13.384-9.62 8.131-3.777 16.313-3.984 21.2-1.967 2.016.832 3.42 2.02 4.077 3.434z"
    />
    <path
      fill="#887F6B"
      d="M104.5 14.5C88.667 15.27 73.5 23 71 35c-1.5-5 3.24-10.908 12.448-16.501C92.5 13 102.5 13.5 104.5 14.5z"
    />
    <path
      fill="#A49C89"
      d="M164.041 22.484c12.726.585 22.776-1.549 23.01-6.637.068-1.487-.71-3.062-2.163-4.561-3.518-3.63-10.995-6.814-20-7.228-12.726-.584-23.231 3.067-23.465 8.155-.027.593.058 1.16.253 1.704.799 2.218 3.445 4.037 7.878 5.594 3.798 1.333 9.3 2.735 14.487 2.973z"
    />
    <path
      stroke="#281D1B"
      strokeOpacity=".1"
      d="M186.552 15.824c-.05 1.088-.619 2.05-1.711 2.893-1.1.85-2.705 1.553-4.739 2.093-4.063 1.078-9.7 1.466-16.038 1.175-5.124-.236-10.576-1.623-14.344-2.946-2.193-.77-3.916-1.596-5.18-2.486-1.263-.89-2.04-1.824-2.393-2.805a3.873 3.873 0 01-.224-1.512c.05-1.09.65-2.155 1.802-3.147 1.153-.994 2.822-1.883 4.91-2.608 4.173-1.45 9.914-2.213 16.23-1.923 8.925.41 16.262 3.567 19.664 7.076 1.404 1.448 2.082 2.896 2.023 4.19z"
    />
    <path
      fill="#887F6B"
      d="M181.467 9.652c-14.351-5.814-31.276-6.054-38.939 2.079.945-4.417 7.821-7.002 18.505-7.542 10.504-.53 19.12 3.893 20.434 5.463z"
    />
    <path
      fill="#A49C89"
      d="M253.349 203.649c8.099 2.555 16.957-3.492 21.941-19.294 1.457-4.618 2.421-9.559 2.854-14.303 1.049-11.486-1.016-21.816-6.748-23.624-8.1-2.555-18.706 8.184-23.69 23.985a65.653 65.653 0 00-1.444 5.312c-1.559 6.939-1.485 12.748.054 17.842 1.318 4.365 3.731 9.041 7.033 10.082z"
    />
    <path
      stroke="#281D1B"
      strokeOpacity=".1"
      d="M274.813 184.205c-2.474 7.845-5.893 13.209-9.643 16.295-3.735 3.073-7.801 3.893-11.671 2.672-1.486-.468-2.833-1.781-3.989-3.587-1.149-1.794-2.065-4.009-2.715-6.162-1.508-4.993-1.591-10.712-.045-17.589.379-1.685.856-3.44 1.433-5.271 2.473-7.841 6.335-14.401 10.555-18.675 4.242-4.294 8.729-6.175 12.507-4.983 2.609.822 4.493 3.63 5.584 7.831 1.083 4.171 1.338 9.563.817 15.27-.43 4.71-1.387 9.616-2.833 14.199z"
    />
    <path
      fill="#887F6B"
      d="M277.827 165.233C274 134.5 256.5 149 247.894 171.521c4.023-14.46 13.216-25.016 20.757-24.91 6.956.097 9.345 8.714 9.176 18.622z"
    />
    <path
      fill="#A49C89"
      d="M203.556 263.935c2.308 3.298 7.383 3.58 13.816-.923a32.773 32.773 0 005.2-4.554c3.708-4.015 5.913-8.495 4.279-10.828-2.308-3.298-9.394-2.321-15.826 2.182a30.887 30.887 0 00-2.076 1.58c-2.588 2.159-4.236 4.364-5.128 6.724-.764 2.021-1.206 4.475-.265 5.819z"
    />
    <path
      stroke="#281D1B"
      strokeOpacity=".1"
      d="M217.085 262.603c-3.169 2.218-5.953 3.22-8.185 3.296-2.213.075-3.889-.757-4.934-2.251-.372-.53-.503-1.338-.418-2.326.083-.975.37-2.047.741-3.03.854-2.26 2.441-4.398 4.98-6.516a30.544 30.544 0 012.042-1.554c3.165-2.216 6.472-3.549 9.242-3.931 2.8-.386 4.898.21 5.889 1.626.662.945.605 2.429-.188 4.301-.78 1.844-2.22 3.92-4.049 5.901a32.278 32.278 0 01-5.12 4.484z"
    />
    <path
      fill="#887F6B"
      d="M223.843 256.555c7.429-12.658-3.334-12.256-13.067-6.272 5.684-4.276 12.186-5.592 14.99-3.377 2.588 2.044.999 5.973-1.923 9.649z"
    />
    <path
      fill="#A49C89"
      d="M193.749 86.843c13.761-3.687 22.58-13.736 18.805-27.828-1.104-4.119-3.162-8.128-5.865-11.646-6.545-8.519-16.875-14.166-26.614-11.556-13.761 3.687-21.856 18.1-18.08 32.191.44 1.644.977 3.17 1.611 4.582 2.586 5.767 6.79 9.67 12.653 12.107 5.022 2.087 11.88 3.653 17.49 2.15z"
    />
    <path
      stroke="#281D1B"
      strokeOpacity=".1"
      d="M212.071 59.145c1.851 6.91.61 12.787-2.747 17.391-3.368 4.618-8.902 8.001-15.705 9.824-5.452 1.461-12.185-.058-17.169-2.129-5.752-2.39-9.857-6.206-12.388-11.85a29.912 29.912 0 01-1.584-4.506c-3.708-13.836 4.243-27.966 17.727-31.58 9.466-2.536 19.608 2.945 26.087 11.378 2.668 3.472 4.694 7.422 5.779 11.472z"
    />
    <path
      fill="#887F6B"
      d="M202.825 44.302c-12.488-11.17-37.318-10.524-39.772 24.33-4.249-12.535 1.888-25.876 13.097-30.856 10.342-4.594 19.942-.33 26.675 6.526z"
    />
    <g>
      <path
        fill="#A49C89"
        d="M257.352 65.122c3.167-3.382.072-11.235-10.868-21.48a102.464 102.464 0 00-10.163-8.337c-8.356-5.99-16.345-9.677-18.586-7.283-3.167 3.382 3.134 14.43 14.074 24.674a97.02 97.02 0 003.714 3.313c4.902 4.143 9.224 6.83 13.245 8.354 3.445 1.305 7.293 2.138 8.584.76z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M246.143 44.007c5.447 5.101 8.906 9.576 10.614 13.164 1.721 3.615 1.593 6.154.23 7.61-.219.234-.581.409-1.115.494-.532.085-1.19.074-1.941-.022-1.5-.192-3.282-.712-4.986-1.357-3.951-1.497-8.224-4.148-13.1-8.269a98.418 98.418 0 01-3.695-3.296c-5.443-5.098-9.718-10.383-12.234-14.793-1.26-2.208-2.064-4.172-2.365-5.768-.305-1.608-.082-2.733.549-3.406.405-.433 1.132-.655 2.267-.558 1.122.096 2.538.5 4.177 1.176 3.273 1.35 7.324 3.746 11.486 6.73a101.975 101.975 0 0110.113 8.295z"
      />
      <path
        fill="#887F6B"
        d="M232.696 33.22c-12.553-7.669-22.273-6.01-.036 19.89-10.095-9.07-16.483-19.232-15.221-23.45 1.165-3.89 7.933-1.191 15.257 3.56z"
      />
    </g>
    <g>
      <path
        fill="#A49C89"
        d="M57.356 170.711c3.349-12.498-.262-23.92-12.493-27.197-3.575-.958-7.49-1.114-11.327-.543-9.286 1.382-18.102 7.027-20.472 15.872-3.35 12.498 3.851 25.286 16.082 28.564 1.427.382 2.807.636 4.148.763 5.467.519 10.257-1.065 14.685-4.61 3.794-3.037 8.012-7.754 9.377-12.849z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M44.734 143.997c5.972 1.6 9.806 5.171 11.757 9.85 1.959 4.698 2.037 10.559.382 16.735-1.325 4.944-5.447 9.578-9.206 12.587-4.337 3.472-9 5.009-14.326 4.503a24.76 24.76 0 01-4.065-.748c-11.955-3.203-19.01-15.71-15.73-27.952 2.3-8.584 10.894-14.141 20.064-15.507 3.776-.562 7.622-.407 11.124.532z"
      />
      <path
        fill="#887F6B"
        d="M29.524 144.658c-12.33 12.058-12.716 29.741.563 42.192-11.276-2.213-18.543-12.98-17.296-24.038 1.151-10.201 8.608-15.884 16.733-18.154z"
      />
    </g>
    <g>
      <path
        fill="#A49C89"
        d="M44.51 100.353c5.218-5.218 7.033-11.548 2.598-15.983-1.297-1.297-2.984-2.288-4.852-2.911-4.525-1.51-10.115-.861-13.808 2.831-5.218 5.218-5.852 13.044-1.417 17.479.517.518 1.053.963 1.608 1.337 2.266 1.529 4.86 1.889 7.88 1.223 2.587-.571 5.864-1.849 7.991-3.976z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M46.754 84.723c2.092 2.091 2.706 4.61 2.185 7.248-.527 2.661-2.218 5.463-4.782 8.028-2.032 2.031-5.203 3.28-7.746 3.841-2.915.643-5.362.289-7.492-1.148a10.477 10.477 0 01-1.534-1.276c-4.189-4.189-3.662-11.693 1.416-16.772 3.53-3.53 8.91-4.174 13.296-2.71 1.806.601 3.423 1.555 4.657 2.79z"
      />
      <path
        fill="#887F6B"
        d="M39.975 81.33c-9.063 2.905-14.519 11.306-12.361 20.392-4.33-3.7-4.33-10.571-.473-15.59 3.559-4.629 8.558-5.613 12.834-4.802z"
      />
    </g>
    <g opacity=".9">
      <path
        fill="#A49C89"
        d="M90.17 97.917c1.494-2.424 1.612-4.963-.45-6.233-.602-.372-1.324-.594-2.081-.661-1.834-.163-3.875.578-4.933 2.294-1.494 2.424-1.035 5.42 1.026 6.69.24.148.48.267.723.359.987.372 1.993.276 3.068-.243.92-.445 2.037-1.217 2.646-2.206z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M89.458 92.11c.879.54 1.285 1.334 1.32 2.277.037.966-.32 2.11-1.034 3.268-.538.873-1.559 1.592-2.439 2.017-.977.473-1.84.54-2.674.226a3.707 3.707 0 01-.637-.317c-1.764-1.087-2.254-3.745-.862-6.002.937-1.52 2.773-2.209 4.463-2.058.69.062 1.336.263 1.863.588z"
      />
      <path
        fill="#887F6B"
        d="M86.771 91.178c-3.144 1.898-4.445 5.54-2.825 8.76-1.956-1.005-2.568-3.585-1.567-5.813.924-2.056 2.714-2.87 4.392-2.947z"
      />
    </g>
    <g opacity=".9">
      <path
        fill="#A49C89"
        d="M90 134.5c1-3.5-.622-5.231-2.832-6.218-.647-.289-1.392-.413-2.151-.38-1.84.08-3.765 1.085-4.587 2.925-1.161 2.6-.31 5.509 1.9 6.496.258.115.512.202.764.26 1.027.239 2.91.074 3.906-.583 1-.5 2.527-1.44 3-2.5z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M86.776 136.553l-.026.013-.025.016c-.408.27-1.043.461-1.73.55-.684.088-1.349.066-1.788-.036a3.667 3.667 0 01-.673-.229c-1.892-.845-2.729-3.415-1.647-5.836.728-1.631 2.457-2.556 4.152-2.63.693-.03 1.359.085 1.925.338 1.055.471 1.904 1.092 2.388 1.954.472.843.638 1.996.177 3.634-.191.405-.603.831-1.134 1.235-.534.405-1.136.75-1.619.991z"
      />
      <path
        fill="#887F6B"
        d="M84.177 128.17c-2.866 2.297-3.674 6.078-1.644 9.056-2.071-.737-3.019-3.214-2.32-5.555.644-2.159 2.31-3.204 3.964-3.501z"
      />
    </g>
    <g opacity=".9">
      <path
        fill="#A49C89"
        d="M90 202.303c1-3.5-.622-5.23-2.832-6.218-.647-.288-1.392-.413-2.151-.38-1.84.08-3.765 1.085-4.587 2.925-1.161 2.601-.31 5.509 1.9 6.497.258.115.512.201.764.26 1.027.238 2.91.073 3.906-.584 1-.5 2.527-1.44 3-2.5z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M86.776 204.356l-.026.013-.025.017c-.408.269-1.043.46-1.73.549-.684.088-1.349.067-1.788-.035a3.75 3.75 0 01-.673-.23c-1.892-.845-2.729-3.415-1.647-5.836.728-1.63 2.457-2.555 4.152-2.629.693-.03 1.359.084 1.925.337 1.055.471 1.904 1.092 2.388 1.955.472.842.638 1.995.177 3.633-.191.405-.603.831-1.134 1.235-.534.406-1.136.75-1.619.991z"
      />
      <path
        fill="#887F6B"
        d="M84.177 195.974c-2.866 2.297-3.674 6.077-1.644 9.055-2.071-.737-3.019-3.213-2.32-5.554.644-2.16 2.31-3.204 3.964-3.501z"
      />
    </g>
    <g opacity=".9">
      <path
        fill="#A49C89"
        d="M154.664 251.317c2.423-8.526-1.574-12.761-7.01-15.189-1.589-.71-3.419-1.02-5.284-.946-4.514.178-9.233 2.61-11.233 7.091-2.828 6.331-.713 13.431 4.723 15.859.634.283 1.259.496 1.878.641 2.524.592 7.143.206 9.584-1.387 2.45-1.21 6.189-3.488 7.342-6.069z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M147.1 256.938l-.026.013-.025.017c-1.13.737-2.81 1.217-4.55 1.434-1.735.217-3.459.163-4.647-.116a9.855 9.855 0 01-1.788-.611c-5.121-2.287-7.216-9.052-4.471-15.198 1.906-4.268 6.426-6.623 10.797-6.796 1.799-.071 3.55.23 5.06.904 2.668 1.191 4.919 2.799 6.221 5.097 1.29 2.278 1.694 5.313.522 9.463-.53 1.162-1.663 2.303-3.014 3.321-1.353 1.019-2.871 1.876-4.079 2.472z"
      />
      <path
        fill="#887F6B"
        d="M140.311 235.828c-7.016 5.575-8.965 14.788-3.953 22.068-5.091-1.815-7.44-7.864-5.747-13.566 1.563-5.261 5.644-7.792 9.7-8.502z"
      />
    </g>
    <g opacity=".9">
      <path
        fill="#A49C89"
        d="M111.819 63.167c2.422-4.284 2.458-8.676-1.186-10.737-1.066-.602-2.327-.939-3.64-1.006-3.179-.164-6.658 1.248-8.372 4.28-2.422 4.284-1.431 9.427 2.213 11.488.425.24.849.43 1.273.573 1.73.579 3.462.348 5.284-.619 1.562-.828 3.441-2.233 4.428-3.98z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M110.387 52.865c1.666.943 2.483 2.4 2.615 4.138.134 1.761-.438 3.83-1.618 5.918-.921 1.628-2.705 2.977-4.227 3.784-1.727.915-3.317 1.112-4.891.585a6.777 6.777 0 01-1.186-.534c-3.34-1.889-4.349-6.694-2.024-10.806 1.601-2.831 4.877-4.183 7.911-4.027 1.247.064 2.431.383 3.42.942z"
      />
      <path
        fill="#887F6B"
        d="M105.503 51.748c-5.307 3.482-7.314 9.854-4.303 15.31-3.445-1.608-4.673-6.024-3.09-9.937 1.46-3.61 4.499-5.133 7.393-5.373z"
      />
    </g>
    <g opacity=".9">
      <path
        fill="#A49C89"
        d="M185.584 123.09c2.422-4.284 2.458-8.676-1.186-10.737-1.066-.602-2.328-.939-3.641-1.006-3.178-.164-6.657 1.249-8.371 4.28-2.422 4.284-1.432 9.427 2.213 11.488.425.24.849.431 1.273.573 1.729.579 3.462.348 5.284-.618 1.562-.828 3.44-2.234 4.428-3.98z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M184.151 112.789c1.667.942 2.484 2.4 2.616 4.137.134 1.761-.438 3.831-1.619 5.918-.92 1.628-2.705 2.977-4.226 3.784-1.727.916-3.317 1.113-4.892.586a6.769 6.769 0 01-1.185-.534c-3.341-1.889-4.349-6.695-2.024-10.807 1.601-2.831 4.877-4.183 7.911-4.027 1.246.064 2.431.383 3.419.943z"
      />
      <path
        fill="#887F6B"
        d="M179.268 111.671c-8.768 2.829-8.768 11.329-4.303 15.31-3.446-1.607-4.673-6.024-3.09-9.937 1.461-3.61 4.499-5.133 7.393-5.373z"
      />
    </g>
    <g opacity=".9">
      <path
        fill="#A49C89"
        d="M209.608 173.816c1.432-2.532 1.342-5.191-1.03-6.532-.693-.392-1.505-.628-2.342-.703-2.028-.18-4.205.586-5.218 2.378-1.432 2.532-.67 5.672 1.702 7.014.277.156.551.282.825.379 1.115.395 2.212.3 3.347-.239.973-.461 2.132-1.264 2.716-2.297z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M208.332 167.719c1.049.593 1.57 1.455 1.691 2.445.123 1.012-.17 2.202-.85 3.406-.511.903-1.563 1.649-2.495 2.091-1.032.49-1.991.565-2.966.22a4.733 4.733 0 01-.746-.344c-2.105-1.19-2.824-4.013-1.513-6.332.887-1.568 2.838-2.295 4.738-2.126.775.069 1.517.287 2.141.64z"
      />
      <path
        fill="#887F6B"
        d="M205.296 166.739c-5.508 1.489-5.29 6.637-2.346 9.162-2.234-1.062-3.129-3.768-2.221-6.097.837-2.149 2.732-2.993 4.567-3.065z"
      />
    </g>
    <g opacity=".9">
      <path
        fill="#A49C89"
        d="M250.075 115.882c2.242-3.964 2.296-8.018-1.036-9.902-.974-.551-2.13-.855-3.333-.911-2.915-.136-6.111 1.184-7.698 3.99-2.241 3.964-1.358 8.706 1.974 10.59.389.22.777.394 1.165.522 1.583.526 3.173.305 4.849-.595 1.436-.772 3.165-2.078 4.079-3.694z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M248.793 106.415c1.508.853 2.243 2.18 2.355 3.771.114 1.616-.418 3.521-1.508 5.45-.848 1.499-2.485 2.749-3.881 3.499-1.581.85-3.028 1.036-4.455.562a6.095 6.095 0 01-1.075-.483c-3.024-1.71-3.933-6.111-1.785-9.909 1.474-2.608 4.471-3.866 7.238-3.737 1.137.053 2.214.341 3.111.847z"
      />
      <path
        fill="#887F6B"
        d="M244.338 105.375c-8.054 2.653-8.094 10.497-4.019 14.148-3.152-1.466-4.257-5.536-2.786-9.154 1.357-3.338 4.151-4.758 6.805-4.994z"
      />
    </g>
    <g>
      <path
        fill="#A49C89"
        d="M82.349 243.943c-.232-7.375-3.22-13.044-8.733-12.87-1.612.05-3.26.594-4.782 1.524-3.684 2.249-6.617 6.754-6.453 11.974.232 7.376 4.89 13.214 10.404 13.041a8.507 8.507 0 001.824-.249c2.342-.595 4.129-2.232 5.51-4.883 1.183-2.272 2.324-5.53 2.23-8.537z"
      />
      <path
        stroke="#281D1B"
        strokeOpacity=".1"
        d="M73.632 231.572c2.548-.08 4.52 1.175 5.908 3.372 1.401 2.217 2.195 5.38 2.309 9.015.09 2.887-1.011 6.058-2.174 8.29-1.337 2.566-3.025 4.079-5.19 4.629a7.973 7.973 0 01-1.716.234c-2.564.081-4.967-1.234-6.776-3.502-1.809-2.267-3-5.464-3.112-9.055-.158-5.023 2.669-9.367 6.213-11.532 1.46-.892 3.027-1.403 4.538-1.451z"
      />
      <path
        fill="#887F6B"
        d="M68.5 234c-3.561 8.578-1.642 17.823 5.5 22.5-4.5 1.5-10.475-4.205-11-10.5-.5-6 3-10.5 5.5-12z"
      />
    </g>
  </svg>
);

export const PageContainer = styled.div`
  width: 100vw;
  height: 100vh;

  ${({ theme }) => (theme?.notFoundPage ? { ...theme?.notFoundPage } : null)}

  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const PageInner = styled.div`
  width: 100vw;
  height: 100vh;

  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VerticalInnerContent = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 10;
`;

export const VerticalInnerTitle = styled.span`
  font-size: 4vw;
  font-weight: 700;
  text-align: center;
  ${({ theme }) =>
    theme?.notFoundPage?.title ? { ...theme?.notFoundPage?.title } : null}
  @media (max-width: 576px) {
    font-size: 7vw;
  }
`;

export const MoonContainer = styled.div`
  width: auto;
  height: 18vw;

  padding: 0 10px;

  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 576px) {
    height: 28vw;
  }
`;

export const FirstFour = styled.span`
  font-size: 15vw;
  font-weight: 700;
  ${({ theme }) =>
    theme?.notFoundPage?.firstFour
      ? { ...theme?.notFoundPage?.firstFour }
      : null}
  @media (max-width: 576px) {
    font-size: 25vw;
  }
`;
export const LastFour = styled.span`
  font-size: 15vw;
  font-weight: 700;
  color: #dddbd7;
  ${({ theme }) =>
    theme?.notFoundPage?.lastFour ? { ...theme?.notFoundPage?.lastFour } : null}
  @media (max-width: 576px) {
    font-size: 25vw;
  }
`;

export const MoonIcon = styled(MoonSVG)`
  width: 15vw;
  height: 15vw;
  @media (max-width: 576px) {
    width: 25vw;
    height: 25vw;
  }
`;

export const PageText = styled(Link)`
  padding: 0;
  margin: 0;
  font-size: 2vw;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  ${({ theme }) =>
    theme?.notFoundPage?.text ? { ...theme?.notFoundPage?.text } : null}
  @media (max-width: 576px) {
    font-size: 4vw;
  }
`;
